import { Link } from 'react-router-dom';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/9a159650-d207-4927-ac66-460895b17acb/39f67378-3e18-4b3c-b5fd-ca850bf4a203_logo-branco.png?v=f83db6c6c980c4807f6a1735dc9ba965';

const navLinks = [
  { label: 'Início', path: '/' },
  { label: 'Jornada de Avaliação', path: '/jornada' },
  { label: 'Pré-Anamnese Digital', path: '/pre-anamnese' },
  { label: 'Política de Privacidade (LGPD)', path: '/lgpd' },
];

const socialLinks = [
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    color: 'text-pink-300',
    url: 'https://www.instagram.com/neuroelos?utm_source=qr&igsh=ZG45c3Q2bDV1OGF1',
  },
  {
    icon: 'ri-linkedin-line',
    label: 'LinkedIn',
    color: 'text-sky-300',
    url: 'https://www.linkedin.com/in/neuro-elos-91601a3b9',
  },
];

export default function Footer() {
  return (
    <footer className="bg-teal-deeper text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-12 pb-8 md:pt-16 md:pb-10">

        {/* Main grid — 4 colunas no desktop, 1 coluna no mobile */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10 md:mb-12">

          {/* Col 1 — Logo + CTA */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <img
              src={LOGO_URL}
              alt="Logo Neuro Elos"
              className="h-[90px] md:h-[120px] w-auto object-contain mb-5 md:mb-6"
            />
            <h3 className="font-serif text-xl md:text-2xl font-300 leading-tight mb-4 md:mb-6">
              Pronto para começar<br />
              <span className="font-600">esta jornada?</span>
            </h3>
            <a
              href="https://wa.me/5511981882825"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-coral text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full text-sm font-600 font-sans whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-coral-dark w-fit"
            >
              <i className="ri-whatsapp-line" />
              Agendar Avaliação
            </a>
          </div>

          {/* Col 2 — Navegação */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="text-sm font-700 font-sans mb-6 text-coral tracking-widest uppercase">
              Navegação
            </h4>
            <ul className="space-y-4">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm font-sans text-white/75 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Conecte-se */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-sm font-700 font-sans mb-6 text-coral tracking-widest uppercase">
              Conecte-se
            </h4>
            <ul className="space-y-4 mb-8">
              {socialLinks.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 cursor-pointer group"
                  >
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
                      <i className={`${s.icon} ${s.color} text-base`} />
                    </div>
                    <span className="text-sm font-sans text-white/75 group-hover:text-white transition-colors">
                      {s.label}
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            {/* Contato direto */}
            <div className="mt-auto pt-2 space-y-3">
              <a
                href="https://wa.me/5511981882825"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 cursor-pointer group"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
                  <i className="ri-whatsapp-line text-green-300 text-base" />
                </div>
                <span className="text-sm font-sans text-white/75 group-hover:text-white transition-colors">
                  (11) 98188-2825
                </span>
              </a>
            </div>
          </div>

          {/* Col 4 — Neuropsicopedagogia */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="text-sm font-700 font-sans mb-6 text-coral tracking-widest uppercase">
              Neuropsicopedagogia
            </h4>
            <div className="flex items-start justify-center md:justify-start">
              <img
                src="https://storage.readdy-site.link/project_files/9a159650-d207-4927-ac66-460895b17acb/f5af7403-f975-493a-af3c-6f397f91046c_Smbolo-Neuropp.jpg?v=7aea794937d4c1eb62f193340acce767"
                alt="Símbolo da Neuropsicopedagogia"
                className="w-full max-w-[200px] md:max-w-[288px] h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col items-center md:flex-row md:items-center gap-2 md:gap-4">
            <img
              src={LOGO_URL}
              alt="Logo Neuro Elos"
              className="h-8 md:h-9 w-auto object-contain opacity-80"
            />
            <p className="text-white/50 text-xs font-sans text-center md:text-left">
              © 2026 · Avaliação Neuropsicopedagógica Infantil · Todos os direitos reservados
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <a
              href="https://www.ovoscomweb.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-white/70 transition-colors text-xs font-sans cursor-pointer"
            >
              By OvosComWeb
            </a>
            <Link
              to="/lgpd"
              className="text-white/50 hover:text-white/80 transition-colors text-xs font-sans flex items-center gap-1 cursor-pointer"
            >
              <i className="ri-shield-check-line text-teal" /> Em conformidade com a LGPD
            </Link>
            <span className="text-white/50 text-xs font-sans flex items-center gap-1">
              <i className="ri-map-pin-line text-coral" /> Atendimento presencial e online
            </span>
          </div>
        </div>

      </div>
    </footer>
  );
}
